import { FC } from 'react';
import { Span } from 'atoms/Typography';
import styles from '../styles.module.css';

export const JumpMarkTarget: FC<{
  jumpMarkId?: string;
}> = ({ jumpMarkId }) => {
  return <Span className={styles.jumpTarget} id={jumpMarkId} />;
};
